import React from 'react'
import Navbar from '../../components/Public/Navbar'
import Footer from '../../components/Public/Footer'
import Main from './CompetitionRules/Main'

export default function CompetitionRules() {
  return (
    <>
      <Navbar />
      <Main />
      <Footer />
    </>
  )
}
